module.exports = __webpack_public_path__ + "static/media/unavailable.f3bcf97f.svg";